module.exports = __webpack_public_path__ + "img/noun-pet.07badc73.svg";